import React, { Component } from "react";
import { connect } from "react-redux";
import { selectFlight } from "../actions";
import {
	saleTotalPerPassengerType,
	formatCurrency,
	feesTranslations,
	bestMaxMilhasPrice,
	isValid
} from "../shared/utils";
import FormatedCurrency from "./FormatedCurrency";
import Popover from "./Popover";
import { Tooltip } from "react-tippy";
import { PROMOTION_TEXT_TITLE } from "../shared/constants";

class FlighRowPriceCampaing extends Component {
	constructor(props) {
		super(props);
	}
	
	listingPassengers(pricing) {
		let list = [];
		let total = 0;
		let fare = 0;

		const passengersType = {
			adult: "Adulto",
			child: "Criança",
			infant: "Bebê"
		};

		Object.keys(pricing).forEach(item => {
			if (["adult", "child", "infant"].indexOf(item) > -1) {
				fare += pricing[item].fare * pricing[item].quantity;
				total += pricing[item].quantity;
				list.push({
					key: `${pricing[item].quantity} ${passengersType[item]}${
						pricing[item].quantity > 1 ? "s" : ""
					}`,
					value: pricing[item].fare * pricing[item].quantity
				});
			}
		});

		return { total, fare, list };
	}

	listingFees(pricing) {
		let list = [];
		let taxes = {};
		let total = 0;

		Object.keys(pricing).forEach(item => {
			if (["adult", "child", "infant"].indexOf(item) > -1) {
				pricing[item].fees &&
					pricing[item].fees.forEach(fee => {
						if (!taxes[fee.type]) taxes[fee.type] = 0;
						taxes[fee.type] += fee.value * pricing[item].quantity;
						total += fee.value * pricing[item].quantity;
					});
			}
		});

		list.push({ key: "Taxas e encargos", value: total });

		return { total, list };
	}

	renderCiaPrice() {
		const { airline, otaAvailableIn: availableIn, pricing } = this.props.flightdata;

		if (availableIn === "both") {
			const maxPrice = bestMaxMilhasPrice(pricing);

			const maxBoardingTax = maxPrice.adult.fees.find(tax => {
				return tax.type === "BOARDING_TAX";
			});

			let airlineAdultPrice = saleTotalPerPassengerType(pricing.airline.adult);

			if (isValid(maxBoardingTax) === false) {
				const airlineBoardingTax = pricing.airline.adult.fees.find(tax => {
					return tax.type === "BOARDING_TAX";
				});

				if (isValid(airlineBoardingTax)) {
					airlineAdultPrice -= airlineBoardingTax.value;
				}
			}

			return (
				<div className="cia-price">
					<span>{`Na ${airline.toUpperCase()} `}</span>
					<span className={pricing.bestPriceAt === "airline" ? "" : "line-through"}>
						<FormatedCurrency value={airlineAdultPrice} currency=" R$ " />
					</span>
				</div>
			);
		} else {
			let info;

			if (availableIn === "maxmilhas") {
				if (pricing.ota && pricing.ota.checkout && pricing.ota.checkout.target === "viajanet") {
					info = "Disponível MaxMilhas";
				} else {
					info = "Exclusivo na MaxMilhas";
				}
			} else if (availableIn === "airline") {
				info = "Exclusivo na cia aérea";
			}

			return (
				<div className="cia-price">
					<span>{info}</span>
				</div>
			);
		}
	}

	renderHighlightPrice() {
		const {
			direction,
			otaAvailableIn: availableIn,
			pricing
		} = this.props.flightdata;

		const stretch = direction === "outbound" ? "Ida" : "Volta";
		const savings =
			pricing.promotion && pricing.promotion.realPercentDiscount
				? pricing.promotion.realPercentDiscount
				: null;

		let highlightPrice, airlinePrice, listPassengers, listFees, isOTA;

		if (availableIn === "airline") {
			highlightPrice = saleTotalPerPassengerType(pricing.airline.adult);
			listPassengers = this.listingPassengers(pricing.airline);
			listFees = this.listingFees(pricing.airline);
			isOTA = false;
		} else {
			const maxPrice = bestMaxMilhasPrice(pricing);

			highlightPrice = saleTotalPerPassengerType(maxPrice.adult);
			listPassengers = this.listingPassengers(maxPrice);
			listFees = this.listingFees(maxPrice);
			isOTA = pricing.mmBestPriceAt === "ota";

			if (availableIn === "both") {
				airlinePrice = saleTotalPerPassengerType(pricing.airline.adult);
			}
		}

		const withoutAllFees = listFees.list.find(obj => obj.value === null) !== undefined;
		const checkHasDiscount = pricing.promotion && (Math.ceil(pricing.promotion.promoPrice) < Math.ceil(pricing.promotion.originalPrice));

		return (
			<div className="highlight-price">
				<div className={`price ${listPassengers.total > 1 ? "price--small" : ""} `}>
					<div className="promo-box">
						<div className="promo-box__content">
							<strong>{ PROMOTION_TEXT_TITLE }</strong>
						</div>
						<div className="show-prices">
							{ checkHasDiscount && (
									<span className="old-price">
										R${" "}
										<strong className="line-through">
											{formatCurrency(pricing.promotion.oneAdultOriginalPrice, " ")}
										</strong>
									</span>
								)}
							<span>
								R$<strong>{formatCurrency(highlightPrice, " ")}</strong>
								{listPassengers.total === 1 && (
									<div className="price-tootip">
										<Tooltip
											tabIndex={"0"}
											html={<Popover listas={[listPassengers.list, listFees.list]} />}
											position="top"
											arrow={true}
										>
											<i className="tooltip">?</i>
										</Tooltip>
									</div>
								)}
							</span>
						</div>
					</div>
					<div className="small">
						{this.props.searchParams.tripType === "RT" ? `${stretch} por` : "Por"} adulto{" "}
						{withoutAllFees ? "sem" : "com"} taxas {availableIn === "both" && "na MaxMilhas"}
					</div>
				</div>
				{listPassengers.total > 1 && (
					<div className="values-block">
						<div className="value-line">
							<span>
								Valor total{this.props.searchParams.tripType === "RT"
									? ` do voo de ${stretch.toLowerCase()}`
									: ""}
								<Tooltip
									tabIndex={"0"}
									html={<Popover listas={[listPassengers.list, listFees.list]} />}
									position="top"
									arrow={true}
								>
									<i className="tooltip">?</i>
								</Tooltip>
							</span>
							<strong>{formatCurrency(listPassengers.fare + listFees.total)}</strong>
						</div>
					</div>
				)}

				<div className="savings-tag-wrapper">
					{(airlinePrice === undefined) ? (
						<div className="tag-promotion">
							<span className="tag-promotion__value">SÓ</span>
							<span className="tag-promotion__value">HOJE</span>
						</div>
					) : savings && savings > 0 && (
						<div className="tag-promotion">
							<span className="tag-promotion__value">{savings}%</span>
							<span className="tag-promotion__value">OFF</span>
						</div>
					)}

					<button
						className={`btn btn-success ${
							savings || (airlinePrice && Math.round(airlinePrice) === Math.round(highlightPrice))
								? "btn--tag-margin"
								: ""
						}`}
						onClick={() => {
							this.props.selectFlight(
								this.props.flightdata,
								this.props.searchId,
								this.props.selectedFlights
							);
							window.scrollTo(0, 0);
						}}
					>
						<span className="buy">Comprar</span>
					</button>
				</div>
			</div>
		);
	}

	render() {
		return (
			<div className="col-xs-16 col-md-4 v-center-columns flight-item-price flight-item-price--promotion">
				{this.renderCiaPrice()}
				{this.renderHighlightPrice()}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	searchId: state.searchStatus.searchId,
	searchParams: state.searchParams.params,
	isInternational: state.searchStatus.isInternational,
	selectedFlights: state.selectedFlights
});

const mapDispatchToProps = dispatch => ({
	selectFlight: (flightdata, searchId, selectedFlights) => {
		dispatch(selectFlight(flightdata, searchId, selectedFlights));
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(FlighRowPriceCampaing);
